import * as _ from "underscore";
import * as ko from "knockout";
import * as m from "./app-models";

declare global {
    interface Window { dataLayer: any[]; }
}

export class App {

    static infoToasts: m.InfoToasts;

    public static alertError(msg: string) {
        this.toast(msg, m.AlertTypeEnum.Error);
    }

    public static alertInfo(msg: string) {
        this.toast(msg, m.AlertTypeEnum.Info);
    }

    public static alertSuccess(msg: string) {
        this.toast(msg, m.AlertTypeEnum.Success);
    }

    public static alertWarning(msg: string) {
        this.toast(msg, m.AlertTypeEnum.Warning);
    }

    public static busy(val: boolean): void {
        $(".spinner").toggleClass("hide", !val);
    }

    public static empty(val: any): boolean {
        return (val === "undefined") || (val == null) || (val == "null");
    }

    public static hasVal(val: any): boolean {
        let self = this;
        return !self.empty(val);
    }

    public static initInfoToasts() {
        let infoToasts = document.querySelector('.ko-info-toasts');
        let model = $(infoToasts).find(".ko-info-toasts-model");
        let viewModel = new m.InfoToasts(model.text());
        ko.applyBindings(viewModel, infoToasts, () => this.infoToasts = viewModel);
    }

    public static initTimer() {
        $(".ko-timer").each((i, x) => {
            let model = $(x).find(".ko-timer-model");
            ko.applyBindings(new m.Timer(model.text()), x);
        });
    }

    public static isValid(valid) {
        if (this.empty(valid)) { return true; }
        return Boolean(valid);
    }

    // null-conditional
    public static nullC(obj: any, val: any) {
        let self = this;
        return self.empty(obj) ? null : val;
    }

    public static onEnter(selector: string, action: () => void) {
        // the "Enter" key
        //console.log($(selector).length);
        $(selector).keypress(event => {
            if (event.which == 13) {
                //console.log("Enter");
                event.preventDefault();
                action();
            }
        });
    }

    public static programBgCss(id: number): string {
        switch (+id) {
            case m.ProgramEnum.BikeSport:
                return "bg-bike-sport";
            case m.ProgramEnum.BikeSwim:
                return "bg-bike-swim";
            case m.ProgramEnum.Trail:
                return "bg-mountain-bike";
            case m.ProgramEnum.Sport:
                return "bg-sport";
            case m.ProgramEnum.Swim:
            case m.ProgramEnum.SwimDropIn:
            case m.ProgramEnum.SwimSpring:
                return "bg-swim";
            default:
                return "bg-bike";
        }
    }

    static programCss = [
        { id: m.ProgramEnum.Bike, text: "text-bike", bg: "bg-bike" },
        { id: m.ProgramEnum.Swim, text: "text-swim", bg: "bg-swim" },
        { id: m.ProgramEnum.SwimDropIn, text: "text-swim", bg: "bg-swim" },
        { id: m.ProgramEnum.SwimSpring, text: "text-swim", bg: "bg-swim" },
        { id: m.ProgramEnum.Sport, text: "text-sport", bg: "bg-sport" },
        { id: m.ProgramEnum.Trail, text: "text-trail", bg: "bg-trail" },
        { id: m.ProgramEnum.BikeSport, text: "text-bike-sport", bg: "bg-bike-sport" },
        { id: m.ProgramEnum.BikeSwim, text: "text-bike-swim", bg: "bg-bike-swim" }
    ];

    public static programTextCss(id: number): string {
        switch (+id) {
            case m.ProgramEnum.BikeSport:
                return "text-bike-sport";
            case m.ProgramEnum.BikeSwim:
                return "text-bike-swim";
            case m.ProgramEnum.Trail:
                return "text-mountain-bike";
            case m.ProgramEnum.Sport:
                return "text-sport";
            case m.ProgramEnum.Swim:
            case m.ProgramEnum.SwimDropIn:
            case m.ProgramEnum.SwimSpring:
                return "text-swim";
            default:
                return "text-bike";
        }
    }

    public static programCssText2(id: number): string {
        const match = App.programCss.find(x => x.id.valueOf() === id);
        return match ? match.text : "text-bike";
    }

    public static scrollTop(duration: number) {
        $('html, body').animate({
            scrollTop: 0
        }, duration, 'swing');
    }

    public static showInfo(content: string, title: string): void {
        let $modal = $("#infoModal");
        $modal.find(".modal-title").html(title);
        $modal.find(".modal-body").html(content);
        $modal.modal('show');
    }

    public static toast(message: string, style: m.AlertTypeEnum) {
        this.infoToasts.toast(message, style);
    }

    public static toggleShowModal(id: string, show: boolean) {
        let elem = document.getElementById(id);

        if (show) {
            $(elem).removeClass('hiding');
            $(elem).addClass('showing');

            // Create new background element
            let newElement = document.createElement('div');
            newElement.className = 'floading-modal-bg';
            document.body.appendChild(newElement);
        }
        else {
            $(elem).removeClass('showing');
            $(elem).addClass('hiding');

            let bgElement = document.querySelector(".floading-modal-bg")
            document.body.removeChild(bgElement);
        }
    }

    public static validateEmail(val) {
        if (this.empty(val)) { return false; }
        var re = /\S+@\S+\.\S+/;
        return re.test(val);
    }

    public static validatePassword(email) {
        /*
         * Note: If passes then not valid
         * 
         * Anything with less than eight characters OR 
         * anything with no numbers OR 
         * anything with no uppercase OR 
         * or anything with no lowercase OR 
         * anything with no special characters (omitted).
         */
        //var re = /^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*|[a-zA-Z0-9]*)$/;
        var re = /^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*)$/;
        return !re.test(email);
    }
}

function init() {
    App.initInfoToasts();
    App.initTimer();
}

$(document).ready(() => init());
